export function viewerRequestStatusLabel(status) {
  if (status === "pending_approval") return "Waiting for approval";
  if (status === "pending") return "Submitted";
  if (status === "running") return "In progress";
  if (status === "completed") return "Completed";
  if (status === "failed") return "Failed";
  if (status === "rejected") return "Rejected";
  if (status === "cancelled") return "Cancelled";
  if (status === "skipped") return "Skipped";
  if (status === "refunded") return "Refunded";
  return "Submitted";
}

export function viewerRequestStatusHelp(status) {
  if (status === "pending_approval") return "Waiting for streamer approval.";
  if (status === "pending") return "Your request was received.";
  if (status === "running") return "Your request is being processed.";
  if (status === "completed") return "Your request was completed.";
  if (status === "failed") return "Something went wrong.";
  if (status === "rejected") return "This request was not approved.";
  if (status === "cancelled") return "This request was cancelled.";
  if (status === "skipped") return "This request was skipped.";
  if (status === "refunded") return "This request was refunded.";
  return "Your request was received.";
}

export function viewerRequestStatusTone(status) {
  if (status === "completed") return "success";
  if (status === "failed" || status === "rejected") return "danger";
  if (status === "pending_approval") return "warning";
  return "active";
}
